import { createAllOfEntitySelector, createEntityByIdSelector, createEntityStateSelector } from "./factories";
import { createSelector } from "reselect";
import { orderBy } from "lodash/collection";


/**
 * Returns the full state of all sites.
 *
 * @param {Object} state Application state.
 *
 * @returns {Object} The full state of all sites.
 */
export const getSites = createEntityStateSelector( "sites" );

/**
 * Returns all sites in the state.
 *
 * @function
 *
 * @param {Object} state Application state.
 *
 * @returns {Array} All sites.
 */
export const getAllSites = createAllOfEntitySelector( "sites" );

/**
 * Returns byId part of sites entities in the state.
 *
 * @function
 *
 * @param {Object} state Application state.
 *
 * @returns {Array} byId part sites entities.
 */
export const getSitesById = createEntityByIdSelector( "sites" );

export const getViewableSites = createSelector(
	getAllSites,
	sites => {
		const viewableSites = sites.map( site => {
			const siteProps = {
				...site,
				siteName: ( site.path === "/" ) ? site.hostname : ( site.hostname + site.path ),
				siteType: site.type,
			};

			if ( site.icon ) {
				siteProps.siteIcon = site.icon;
			}

			return siteProps;
		} );

		return orderBy(
			viewableSites,
			"siteName",
			"asc",
		);
	},
);
